import Link                                                      from "next/link";
import { Crown, Medal, Award, TrendingUp, Skull }                from "lucide-react";
import Avatar                                                    from "@/components/Avatar";
import PatenteBadge                                              from "@/components/PatenteBadge";
import { ReisCoroas }                                            from "@/components/ReisDoJogador";
import { formatar_numero, texto_posicao, link_do_jogador }       from "@/utils/RpgFunction";

const getRankIcon = (rank) => {
  if (rank === 1) return <div className="icon_rankings"><Crown className="w-5 h-5 text-cosmic-gold" /></div>;
  if (rank === 2) return <div className="icon_rankings"><Medal className="w-5 h-5 text-gray-300" /></div>;
  if (rank === 3) return <div className="icon_rankings"><Award className="w-5 h-5 text-amber-600" /></div>;
  return null;
};

const getRankBadgeClass = (rank) => {
  if (rank === 1) return "rank-badge rank-1";
  if (rank === 2) return "rank-badge rank-2";
  if (rank === 3) return "rank-badge rank-3";
  return "rank-badge bg-secondary text-secondary-foreground";
};

// Cartao do Top 5 da home: posicao por XP, foto, nome, crew, patente e nivel.
export default function PlayerCard({ jogador }) {
  if (!jogador) return null;

  const rank    = jogador.posicao;
  const podio   = typeof rank === "number" && rank <= 3;
  const href    = link_do_jogador(jogador) || "/rankings";

  return (
    <Link
      href={href}
      className={`void-card-hover block p-4 ${(rank === 1) ? "void-glow-intense" : ""}`}
    >
      <div className="flex items-center gap-4">
        {/* Rank */}
        <div className="flex-shrink-0 w-12 text-center">
          { getRankIcon(rank) || (<span className="font-orbitron text-xl text-muted-foreground">{texto_posicao(rank)}</span>) }

          { podio && ( <span className={getRankBadgeClass(rank) + " mt-1 text-xs"}>{texto_posicao(rank)}</span> )}
        </div>

        {/* Avatar */}
        <div className="relative flex-shrink-0">
          <div className={`w-14 h-14 rounded-xl overflow-hidden border-2 ${
            rank === 1 ? "border-cosmic-gold" :
            rank === 2 ? "border-gray-400" :
            rank === 3 ? "border-amber-600" : "border-border"
          }`}>
            <Avatar
              src={jogador.avatar}
              alt={jogador.nome}
              className="w-full h-full object-cover"
            />
          </div>
          {podio && (
            <div className="absolute -bottom-1 -right-1 w-6 h-6 rounded-full bg-gradient-void flex items-center justify-center void-glow">
              {getRankIcon(rank)}
            </div>
          )}
        </div>

        {/* Info */}
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 min-w-0">
            <h3 className="font-orbitron font-bold text-foreground truncate">
              {jogador.nome}
            </h3>
            <ReisCoroas reis={jogador.reis} />
          </div>

          <div className="flex flex-wrap items-center gap-x-2 gap-y-1 mt-1 min-w-0">
            <p className="text-sm text-muted-foreground min-w-0 icon_crew_player">
              <Skull className="w-5 h-5 flex-shrink-0" /><span className="truncate">{jogador.crew?.nome || "Sem crew"}</span>
            </p>
            <PatenteBadge patente={jogador.patente} />
          </div>
        </div>

        {/* Nivel */}
        <div className="flex-shrink-0 text-right">
          <div className="flex items-center justify-end gap-1 text-primary">
            <TrendingUp className="w-4 h-4" />
            <span className="font-orbitron font-bold text-lg">Nv. {formatar_numero(jogador.nivel)}</span>
          </div>
          <p className="text-xs text-muted-foreground">{formatar_numero(jogador.xp)} XP</p>
        </div>
      </div>
    </Link>
  );
}
